import { FaroRoutes } from '@grafana/faro-react';
import { LoginPage } from '@pages/Anonymous/LoginPage';
import { PasswordRecoveryPage } from '@pages/Anonymous/PasswordRecoveryPage';
import { PasswordResetPage } from '@pages/Anonymous/PasswordResetPage';
import { RegistrationPage } from '@pages/Anonymous/RegistrationPage';
import { RegistrationSuccessPage } from '@pages/Anonymous/RegistrationSuccessPage';
import { RegistrationTokenExpiredPage } from '@pages/Anonymous/RegistrationTokenExpiredPage';
import { routes } from '@routes';
import { GuestAppWrapper } from '@wrappers/GuestApp';
import { Helmet } from 'react-helmet-async';
import { Route, Routes } from 'react-router-dom';
import { RedirectToSignin } from './components/RedirectToSignin';

export const GuestRoutes = () => (
  <FaroRoutes routesComponent={Routes}>
    <Route element={<GuestAppWrapper />}>
      <Route
        path={routes.signin.pattern}
        element={
          <>
            <Helmet>
              <title>Login - AutoScript</title>
            </Helmet>
            <LoginPage />
          </>
        }
      />

      <Route
        path={routes.signup.pattern}
        element={
          <>
            <Helmet>
              <title>Sign Up - AutoScript</title>
            </Helmet>
            <RegistrationPage />
          </>
        }
      />

      <Route
        path={routes.passwordRecovery.pattern}
        element={
          <>
            <Helmet>
              <title>Password Recovery - AutoScript</title>
            </Helmet>
            <PasswordRecoveryPage />
          </>
        }
      />

      <Route
        path={routes.passwordReset.pattern}
        element={
          <>
            <Helmet>
              <title>Password Recovery - AutoScript</title>
            </Helmet>
            <PasswordResetPage />
          </>
        }
      />

      <Route
        path={routes.registerSuccess.pattern}
        element={
          <>
            <Helmet>
              <title>Registration - AutoScript</title>
            </Helmet>
            <RegistrationSuccessPage />
          </>
        }
      />

      <Route
        path={routes.registerTokenExpired.pattern}
        element={
          <>
            <Helmet>
              <title>Registration - AutoScript</title>
            </Helmet>
            <RegistrationTokenExpiredPage />
          </>
        }
      />

      <Route path="*" element={<RedirectToSignin />} />
    </Route>
  </FaroRoutes>
);
